// global.BaseUrl = 'https://foodweb-emu.ksoftpl.com/emu-backend/public/api';
// global.AssetsUrl = 'https://foodweb-emu.ksoftpl.com/emu-backend/public/';

global.BaseUrl = 'https://admin.foodweb-emu.ksoftpl.com/api';
global.AssetsUrl = 'https://admin.foodweb-emu.ksoftpl.com';

// global.BaseUrl = 'http://localhost/emu-backend/public/api';
// global.AssetsUrl = 'http://localhost/emu-backend/public';